import React from "react";
import { Box } from "@mui/material";
import { MicroLabel } from "./MicroLabel";
import { StatusLine } from "./StatusLine";
import { StatusTone } from "./types";

export type OperatorEmptyStateProps = {
  /** Optional uppercase mono kicker above the status line. */
  kicker?: React.ReactNode;
  children: React.ReactNode;
  tone?: StatusTone;
  /** Optional action control(s) below the message. */
  action?: React.ReactNode;
};

export function OperatorEmptyState({
  kicker,
  children,
  tone = "neutral",
  action,
}: OperatorEmptyStateProps) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 1,
        py: 3,
        px: 2,
        textAlign: "center",
      }}
    >
      {kicker != null ? <MicroLabel>{kicker}</MicroLabel> : null}
      <StatusLine tone={tone}>{children}</StatusLine>
      {action != null ? <Box sx={{ mt: 0.5 }}>{action}</Box> : null}
    </Box>
  );
}
